import { useRef, useState } from 'react'

const useUnsavedChangesModal = ({ hasChanges, onDiscard }) => {
  const [showUnsavedChangesModal, setShowUnsavedChangesModal] = useState(false)
  const pendingLeave = useRef(onDiscard)

  const handleLeave = leave => {
    if (hasChanges) {
      pendingLeave.current = leave
      setShowUnsavedChangesModal(true)
      return
    }

    leave()
  }

  const handleCancel = () => handleLeave(onDiscard)

  const handleKeepEditing = () => setShowUnsavedChangesModal(false)

  const handleDiscardChanges = () => {
    setShowUnsavedChangesModal(false)
    pendingLeave.current()
  }

  return { showUnsavedChangesModal, handleLeave, handleCancel, handleKeepEditing, handleDiscardChanges }
}

export default useUnsavedChangesModal
